
<div v-if="isIOS" class="VideoPlayer VideoPlayer--native">
    <video
        ref="nativeVideo"
        :src="src"
        :poster="poster"
        :title="title"
        :loop="loop"
        controls
        playsinline
        preload="metadata"
        style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px"
    >
        Ihr Browser unterstützt das Video-Element nicht.
    </video>
</div>

<div
    v-else
    class="VideoPlayer"
    :class="{ 'is-playing': isPlaying, 'is-fullscreen': isFullscreen }"
    @mousemove="onMouseMove"
    @mouseleave="onMouseLeave"
>
    <div class="VideoContainer" ref="videoContainer">
        <video
            ref="video"
            :src="src"
            :poster="poster"
            :title="title"
            :loop="loop"
            preload="metadata"
            playsinline
            @loadedmetadata="onLoadedMetadata"
            @timeupdate="onTimeUpdate"
            @ended="onEnded"
            @play="onPlay"
            @pause="onPause"
            @volumechange="onVolumeChange"
            @click="togglePlay"
            @waiting="onWaiting"
            @canplay="onCanPlay"
        >
            <track kind="captions" />
            Ihr Browser unterstützt das Video-Element nicht.
        </video>

        <!-- Play/Pause Overlay -->
        <div class="PlayOverlay" v-if="!isPlaying && !isLoading" @click="togglePlay">
            <div class="PlayButton">
                <i class="ri-play-fill"></i>
            </div>
        </div>

        <!-- Loading Overlay -->
        <div class="LoadingOverlay" v-if="isLoading">
            <div class="LoadingSpinner">
                <i class="ri-loader-4-line"></i>
            </div>
        </div>

        <!-- Controls -->
        <div class="VideoControls" :class="{ 'is-visible': showControls }">
            <!-- Progress Bar -->
            <div class="ProgressContainer">
                <div
                    class="ProgressBar"
                    ref="progressBar"
                    @click="seekTo"
                    @mousedown="startSeeking"
                    @touchstart="startSeekingTouch"
                >
                    <div class="ProgressBackground"></div>
                    <div class="ProgressFilled" :style="{ width: progressPercent + '%' }"></div>
                    <div class="ProgressHandle" :style="{ left: progressPercent + '%' }"></div>
                </div>
            </div>

            <!-- Control Buttons -->
            <div class="ControlsRow">
                <div class="ControlsLeft">
                    <button
                        class="ControlButton"
                        @click="togglePlay"
                        :title="isPlaying ? 'Pause' : 'Play'"
                    >
                        <i :class="isPlaying ? 'ri-pause-fill' : 'ri-play-fill'"></i>
                    </button>

                    <div class="VolumeContainer">
                        <button
                            class="ControlButton"
                            @click="toggleMute"
                            :title="isMuted ? 'Stummschaltung aufheben' : 'Stummschalten'"
                        >
                            <i :class="volumeIcon"></i>
                        </button>
                        <div
                            class="VolumeSlider"
                            ref="volumeSlider"
                            @click="setVolume"
                            @mousedown="startVolumeChange"
                            @touchstart="startVolumeChangeTouch"
                        >
                            <div class="VolumeBackground"></div>
                            <div
                                class="VolumeFilled"
                                :style="{ width: volumePercent + '%' }"
                            ></div>
                            <div
                                class="VolumeHandle"
                                :style="{ left: volumePercent + '%' }"
                            ></div>
                        </div>
                    </div>

                    <div class="TimeDisplay">
                        <span>{{ formatTime(currentTime) }}</span>
                        <span>/</span>
                        <span>{{ formatTime(duration) }}</span>
                    </div>
                </div>

                <div class="ControlsRight">
                    <button
                        class="ControlButton"
                        @click="toggleFullscreen"
                        :title="isFullscreen ? 'Vollbildmodus beenden' : 'Vollbildmodus'"
                    >
                        <i
                            :class="
                                isFullscreen ? 'ri-fullscreen-exit-fill' : 'ri-fullscreen-fill'
                            "
                        ></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
